import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

const InstitutionalGroup = () => {
	return {
		componentName: 'VisibilityLayout',
		componentGroup: 'InstitutionalGroup',
		componentId: uuidv4(),
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Conteúdo Institucional (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'img-and-text__row-container-2',
					preserveLayoutOnMobile: true,
					preventHorizontalStretch: true,
				},
				[
					FlexLayoutCol(
						{
							width: { desktop: 'auto', mobile: '100%' },
							horizontalAlign: 'right',
							blockClass: 'img-and-text__img-col-2',
						},
						[
							Image({
								blockClass: 'img-and-text__image-2',
								src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060245014-Slider-Banner-Mobile.png',
							}),
						],
					),
					FlexLayoutCol({ width: { desktop: 'grow', mobile: '100%' }, blockClass: 'img-and-text__text-col-2' }, [
						RichText({
							blockClass: 'img-and-text__text-2',
							text: 'Texto de **Exemplo**\n\n\n Digite aqui seu texto',
						}),
					]),
				],
			),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--iat-2-bg-color', name: 'Background' },
			{ from: '--text-color-1', to: '--iat-2-text-color', name: 'Text' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--iat-2-img-border', name: 'Image' }],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--iat-2-typography', name: 'Text' }],
	},
];
export default InstitutionalGroup;
